import { Either } from "fp-ts/lib/Either";
import ExceptionEntity from "../../../../../domain/entities/ExceptionEntity";
import EventScheduleEntity from "../../../../../domain/entities/EventScheduleEntity";

//TODO implement
const CreateEventForShiftApiImpl = (event: EventScheduleEntity, shiftId: string):  Promise<Either<ExceptionEntity, EventScheduleEntity>> => {
    throw new Error('Method not implemented.');
}

export default CreateEventForShiftApiImpl;